'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16() {
}
export { $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16 as $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16 };
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16.prototype.constructor = $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16() {
}
export { $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16 as $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16 };
$h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16.prototype = $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16.prototype;
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16.prototype.compose__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this, g);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16.prototype.andThen__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__andThen__F1__F1(this, g);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16.prototype.apply__O__O = (function(v1) {
  return v1;
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return v1;
});
var $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16, "app.data.GeneralPracticeUserOutOfOffice$$anon$16", ({
  Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16: 1,
  F1: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction1: 1
}));
export { $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16 as $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16 };
//# sourceMappingURL=app.data.-General-Practice-User-Out-Of-Office$$anon$16.js.map
